import { createStyles, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) =>
  createStyles({
    '@global': {
      '*': {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
      },
      html: {
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        height: '100%',
        width: '100%',
      },
      body: {
        height: '100%',
        width: '100%',
      },
      a: {
        textDecoration: 'none',
        color: theme.palette.primary.main,
      },
      '#root': {
        height: '100%',
        width: '100%',
      },
    },
  })
)

const GlobalStyles: React.FC<{}> = () => {
  useStyles()

  return null
}

export default GlobalStyles
